import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles.css'

// Note: NOT using <React.StrictMode> in production — captive portal popup
// browsers (iOS especially) sometimes mishandle StrictMode's double-mount
// behavior, causing the unlock timer to fire twice (5s + 5s = 10s wait).
createRoot(document.getElementById('root')!).render(<App />)
